
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { UserModule } from '@/store/modules/user'
import { UserService } from '@/services/index'

@Component({
    components: {
    }
})
export default class extends Vue {
    private loading: boolean = false
    // 编辑表单
    private userForm: any = {
        name: '',
        password: '',
        confirmPassword: '',
        mobile: '',
        email: '',
        department: ''
    }
    private userRules = {
        name: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 2, max: 10, message: '姓名长度为 2-10 个字符', trigger: 'blur' }
        ],
        mobile: [
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
            { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        department: [],
        password: [
            { validator: this.validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
            { validator: this.validateSamePassword, trigger: 'blur' }
        ]
    }

    private mounted() {
        this.initData()
    }

    /** 获取当前用户信息并回显 */
    private async initData() {
        const result = await UserService.getUserInfo({ id: UserModule.userId })
        if (result.status === 200) {
            const user = result.data
            this.userForm = {
                name: user.name || '',
                password: '',
                confirmPassword: '',
                mobile: user.mobile || '',
                email: user.email || '',
                department: user.department || ''
            }
        } else {
            this.$message({ type: 'error', message: result.message || '获取用户信息失败' })
        }
    }

    /** 密码校验: 留空表示不修改, 非空时至少 6 位 */
    private validatePassword(rule: any, value: string, callback: Function) {
        if (value && value.length < 6) {
            callback(new Error('密码不能少于 6 个字符'))
        } else {
            callback()
        }
    }

    /** 确认密码校验: 两次同时为空不校验, 非空时必须一致 */
    private validateSamePassword(rule: any, value: string, callback: Function) {
        const pwd = this.userForm.password
        if (!pwd && !value) {
            callback()
        } else if (pwd && value && pwd === value) {
            callback()
        } else if (pwd && !value) {
            callback(new Error('请再次输入新密码'))
        } else {
            callback(new Error('两次输入的密码不一致'))
        }
    }

    /** 注销当前登录账号：二次确认后调用接口将自身 role 置为 -1（停用账户） */
    private handleCancelAccount() {
        this.$confirm(
            '确认注销本账号？注销后账号将被停用，无法登录，该操作不可恢复！',
            '账号注销',
            {
                confirmButtonText: '确认注销',
                cancelButtonText: '取消',
                type: 'warning',
                distinguishCancelAndClose: true
            }
        ).then(async () => {
            const result = await UserService.cancelMyAccount({
                id: UserModule.userId,
                role: -1
            })
            if (result.status === 200) {
                this.$message({ type: 'success', message: '账号注销成功，即将退出登录' })
                // 稍作停留展示成功提示，再退出登录并跳转登录页
                setTimeout(() => {
                    UserModule.logOut().then(() => {
                        window.location.href = '#/login'
                    })
                }, 1000)
            } else {
                this.$message({ type: 'error', message: result.message || '注销失败，请重试' })
            }
        }).catch(() => {
            // 用户点击取消/关闭，不执行任何操作
        })
    }

    /** 重置：回显最新信息 */
    private onReset() {
        this.initData()
        ;(this.$refs.userForm as ElForm).clearValidate()
    }

    /** 取消：返回上一页 */
    private onCancel() {
        this.$router.go(-1)
    }

    /** 保存修改 */
    private onUpdate() {
        (this.$refs.userForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                const { name, mobile, email, department, password } = this.userForm
                const params = {
                    id: UserModule.userId,
                    name,
                    mobile,
                    email,
                    department,
                    password: password || '',
                    role: UserModule.role
                }
                const result = await UserService.updateUser(params)
                if (result.status === 200) {
                    this.$message({ type: 'success', message: '修改成功' })
                    // 清空密码框，重新拉取最新数据回显
                    this.initData()
                    ;(this.$refs.userForm as ElForm).clearValidate()
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.loading = false
            } else {
                return false
            }
        })
    }
}
